import { useCallback } from "react";
import "./_leaderboards-status-badge.scss";

const LeaderboardsStatusBadge = ({ status, startsAt, awardApproval }) => {
  const getStatus = useCallback(() => {
    const date = new Date(startsAt) < new Date();
    switch (status) {
      case "DRAFT":
        return { className: "not-started", text: "Not Started" };
      case "ACTIVE":
        return date
          ? { className: "active", text: "Active" }
          : { className: "not-started", text: "Not Started" };
      case "COMPLETED":
        return awardApproval === "MANUAL"
          ? { className: "pending-review", text: "Completed - Pending Review" }
          : { className: "approved", text: "Approved" };
      case "APPROVED":
        return { className: "approved", text: "Approved" };
      case "LEADERBOARD":
        return { className: "leaderboard", text: "Leaderboard" };
      case "ARCHIVED":
        return { className: "archived", text: "Archived" };
      default:
        return { className: status, text: status };
    }
  }, [awardApproval, status, startsAt]);
  return (
    <div className="leaderboards-header-status display-flex flex-direction-row align-items-center justify-content-space-between">
      <div className="status-badges display-flex flex-direction-row">
        <div
          className={`status ${getStatus().className}`}
          data-testid="leaderboards-status-badge"
        >
          {getStatus().text}
        </div>
      </div>
    </div>
  );
};

export default LeaderboardsStatusBadge;
